export const hi= {
    'buttons': {
        'return': 'वापसी'
    },
    'selects': {
        'currency': {
            'label': 'मुद्रा',
            'placeholder': 'मुद्रा चुनें',
            'options-title': 'उपलब्ध सिक्कों की सूची'
        },
        'currency-and-network': {
            'placeholder': 'मुद्रा और नेटवर्क चुनें',
            'options-title': 'उपलब्ध सिक्कों की सूची'
        },
        'selected-label': 'चयनित: {selected} में से {length}',
        'search': 'खोजें',
        'errors': {
            'invalid': 'अमान्य मान',
            'required': 'आवश्यक',
            'card-holder': 'कार्डधारक का पहला और अंतिम नाम दर्ज करें',
            'input-amount': 'राशि दर्ज करें',
            'fill-card': 'कार्ड विवरण भरें'
        },
        'empty-list': 'खाली सूची',
        'address': {
            'label': '{currency} में निकासी का पता',
            'options-title': 'उपलब्ध पतों की सूची'
        },
        'cardholder-input': {
            'placeholder': 'कार्डधारक'
        }
    },
    'text-fields': {
        'labels': {
            'personal': {
                'address': 'जमा करने के लिए आपका पता'
            },
            'invoice': {
                'address': 'पता',
                'paid-amount': 'भुगतान की गई राशि'
            }
        }
    },
    'labels': {
        'deposit': 'जमा करें',
        'withdraw': 'निकासी',
        'currency': 'मुद्रा',
        'amount': 'राशि',
        'invoice': {
            'remaining-time': 'भुगतान के लिए शेष समय',
            'status': {
                'expires': 'समय समाप्त',
                'success': 'भुगतान सफल',
                'error': 'त्रुटि'
            },
            'partially-paid': {
                'title': 'आंशिक रूप से भुगतान किया गया',
                'info': 'राशि आंशिक रूप से भुगतान की गई है। सफल भुगतान के लिए शेष राशि का भुगतान किया जाना चाहिए।'
            },
            'orphan': {
                'title': 'अनाथ लेनदेन',
                'description': 'इस आदेश के एक लेनदेन में गलत नेटवर्क या मुद्रा है।',
                'contact': 'तकनीकी सहायता से संपर्क करें: '
            },
            'you-paid': 'आपने भुगतान किया',
            'active-order': 'सक्रिय आदेश',
            'new-invoice': 'नया चालान',
            'order-id': 'चालान आईडी',
            'payment-amount': 'भुगतान राशि'
        },
        'continue': 'जारी रखें',
        'payout': {
            'address': '{currency} में निकासी का पता',
            'tag-or-memo': 'टैग या मेमो',
            'status': {
                'processed': 'सफल',
                'error': 'त्रुटि',
                'orphan': 'अनाथ लेनदेन',
                'approve_rejected': 'अस्वीकृत',
                'in-progress': 'प्रगति पर',
                'need-approve': 'मंजूरी आवश्यक',
                'awaiting-confirmation': 'आपका निकासी अनुरोध पुष्टि की प्रतीक्षा कर रहा है'
            },
            'info': {
                'withdraw-id': 'निकासी आईडी',
                'tx-hash': 'TX हैश',
                'currency-and-network': 'मुद्रा और नेटवर्क',
                'address': 'पता',
                'tag-or-memo': 'टैग या मेमो',
                'amount': 'निकासी राशि'
            }
        },
        'fiat': {
            'title': 'फिएट के माध्यम से जमा',
            'info': {
                'amount': 'राशि',
                'date': 'भुगतान की तिथि',
                'id': 'जमा आईडी',
                'system': 'भुगतान प्रणाली'
            },
            'status': {
                'new': 'नया',
                'pending': 'लंबित',
                'authorized': 'अधिकृत',
                'confirmed': 'पुष्ट',
                'reconciled': 'सामंजस्यपूर्ण',
                'error': 'त्रुटि',
                'declined': 'अस्वीकृत'
            }
        }
    },
    'errors': {
        'wrong-widget-id': 'गलत विजेट आईडी',
        'wrong-ext-user-id': 'गलत बाहरी उपयोगकर्ता आईडी',
        '404': 'ओह! हमने खोजा लेकिन वह नहीं मिला जिसकी आप तलाश कर रहे थे।',
        'without-xt-user-id-withdrawal': 'निकासी अनुपलब्ध। extUserId पैरामीटर पारित नहीं किया गया',
        'without-xt-user-id-deposit': 'जमा अनुपलब्ध। extUserId पैरामीटर पारित नहीं किया गया'
    },
    'invoice': {
        'order': 'आदेश',
        'inputs': {
            'email': {
                'label': 'ईमेल पता',
                'placeholder': 'अपना ईमेल पता दर्ज करें'
            },
            'amount': {
                'label': 'राशि',
                'placeholder': 'राशि दर्ज करें'
            }
        },
        'text-fields': {
            'expanded': {
                'in-usd': 'राशि',
                'rate': 'विनिमय दर',
                'payment-id': 'भुगतान आईडी',
                'description': 'विवरण'
            }
        },
        'order-public-link': {
            'do-not-refresh': 'पृष्ठ को रीफ़्रेश न करें या चालान को',
            'new-tab': 'नए टैब में खोलें'
        },
        'statuses': {
            'ERROR': 'त्रुटि',
            'PENDING': 'लंबित',
            'PROCESSED': 'प्रसंस्कृत',
            'REJECTED': 'अस्वीकृत',
            'OVERPAID': 'अधिभुक्त',
            'CREATED': 'निर्मित',
            'PARTIAL': 'आंशिक भुगतान',
            'INIT': 'आरंभ',
            'EXPIRED': 'समाप्त'
        }
    },
    'personal': {
        'titles': {
            'deposit': 'जमा',
            'payment-history': 'भुगतान इतिहास'
        },
        'payment-history': {
            'empty-label': 'आपके द्वारा निर्दिष्ट पते पर भेजे गए सभी लेन-देन यहां उपलब्ध होंगे',
            'headers': {
                'date': 'तिथि और समय',
                'amount': 'राशि',
                'tx': 'लेन-देन हैश',
                'status': 'स्थिति'
            },
            'statuses': {
                'processed': 'प्रसंस्कृत',
                'pending': 'लंबित',
                'rejected': 'अस्वीकृत',
                'error': 'त्रुटि'
            },
            'in': 'में'
        },
        'qr-block': {
            'empty-label': 'क्रिप्टोक्यूरेंसी के साथ पुनःपूर्ति',
            'qr-info-pre-invoice': 'केवल भेजें',
            'qr-info-pre-personal': 'किसी भी राशि को केवल भेजें',
            'qr-info-post': 'इस पते पर',
            'qr-info-minimal': '1 अमरीकी डालर से कम के स्थानान्तरण का श्रेय नहीं दिया जाता है ।'
        }
    },
    'fiat': {
        'titles': {
            'deposit': 'फिएट के माध्यम से जमा',
            'payment-history': 'भुगतान इतिहास'
        },
        'labels': {
            'pay': 'भुगतान करें',
            'service-commission': 'सेवा आयोग की राशि',
            'total': 'कुल',
            'you-pay': 'आप भुगतान करें'
        }
    },
    'popup': {
        'orphan-danger': {
            'title': 'अनाथ लेनदेन',
            'info': 'इस आदेश के एक लेनदेन में गलत नेटवर्क या मुद्रा है।',
            'support': 'तकनीकी सहायता से संपर्क करें: '
        }
    },
    'cookie-policy': {
        'by-clicking': '“जारी रखें” बटन पर क्लिक करके, आप स्वचालित रूप से सहमत होते हैं',
        'our': 'हमारी कुकी नीति'
    },
    'payout': {
        'payout': 'भुगतान',
        'output': 'निकासी',
        'withdraw': 'निकासी',
        'errors': {
            'wrong-address': '{network} नेटवर्क पर पता नहीं है'
        }
    }
}
